export default {"src":"/_next/static/media/lamp.be4e4e90.svg","height":22,"width":23};